import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";

export const RCAPicture = ({pictureURL}: {pictureURL: string}) => (
  <>
    <h5 className="mb-2">
      <strong>Screenshot</strong>
    </h5>
    <a
      target="_blank"
      className="d-block border mb-4"
      aria-label="Root cause analysis screenshot"
      href={`${URL_ORIGINAL_WEBSITE}${pictureURL}`}
    >
      <img className="img-fluid" src={`${URL_ORIGINAL_WEBSITE}${pictureURL}`} alt="root cause analysis picture" />
    </a>
  </>
);
